<template>
  <div id="app" :class="[
    showBackComponent
      ? 'isSpecialChannelEnvironment'
      : 'isNotSpecialChannelEnvironment',
    isFullScreen
      ? 'isFullScreen'
      : iosFillScreen
        ? 'iosFillScreen'
        : 'nonFullScreen',
  ]">
    <transition :name="transitionName">
      <router-view class="router-view-container" />
    </transition>
  </div>
</template>

<script>
import { GetQueryString } from "@/utils";
import jsCookie from "js-cookie";
import { refreshToken } from '@/utils/http'
import { Toast } from 'vant';
import { getRemainCount } from '@/api/main'
export default {
  name: 'App',
  data() {
    return {
      ticket: "",
      refresh_token: "",
      showBackComponent: false,
      isFullScreen: false,
      iosFillScreen: false,
      transitionName: 'slide-left',
      isRouteReady: false,
      historyLength: window.history.length,
      routeList: []  // 用于存储路由历史
    };
  },

  methods: {
    setParams() {
      const params = [
        "watermarkId",
        "projectId",
        "releaseId",
      ];
      params.forEach((param) => {
        const value = GetQueryString(param);
        if (value) {
          sessionStorage.setItem(param, value);
        }
      });
    },
    async _userOauthMigu() {

      const vuid = GetQueryString("vuid");
      const btoken = GetQueryString("btoken");

      if (vuid) {
        jsCookie.set("vuid", vuid);
      }
      if (btoken) {
        jsCookie.set("btoken", btoken);
      }
      localStorage.setItem('backParams', window.location.search)
      this.$store.commit("setTokens", {
        vuid: vuid || jsCookie.get('vuid'),
        btoken: btoken || jsCookie.get('btoken')
      });

      const backUrl = localStorage.getItem('backUrl')
      const backParams = localStorage.getItem('backParams')

      localStorage.removeItem('backUrl')
      localStorage.removeItem('backParams')
      if (GetQueryString('resumeCode') == '5') {
        this.initTask()
        this.$nextTick(() => {
          this.$router.replace('/main' + backParams)
          setTimeout(() => {
            Toast.fail('暂不支持非移动用户')
          }, 1200);
          return
        })
      } else if (GetQueryString('resumeCode') == '2') {
        this.initTask()
        this.$router.replace('/main' + backParams)
        setTimeout(() => {
          this.$nextTick(() => {
            Toast.fail('用户取消支付')
          })
        }, 1200);
        return
      } else if (GetQueryString('resumeCode') == '0') {
        this.$nextTick(() => {
          this.initTask()
          this.$router.replace('/history' + backParams)
          setTimeout(() => {
            Toast.fail('用户支付失败')
          }, 1200);
          return
        })
        if (backUrl) {
          this.$router.replace(backUrl + backParams)
        }
      }else if(GetQueryString('resumeCode') == '4'){
        this.$store.commit('setImage', '')
      }
    },
    async miniappLogin() {
      const params = GetQueryString("refresh_token");
      this.refresh_token = params;
      let token = await refreshToken(this.refresh_token);
      this.ticket = token;
      jsCookie.set("refresh_token", this.refresh_token);
      jsCookie.set("ticket", this.ticket);
    },
    initTask() {
      this.$store.commit('setTemporaryParamsFast', {
        prompt: '',
        music_uuid: '',
        params: {},
      })
      this.$store.commit('setTemporaryParams', {
        prompt: '',
        duration: '',
        style: '',
        music_uuid: '',
      })
      this.$store.commit('setTemporaryParamsAvatar', {

      })
    },
    watchRouter() {
      this.$router.beforeEach((to, from, next) => {
        // 判断是否是返回操作
        const toIndex = this.routeList.indexOf(to.fullPath)
        if (toIndex !== -1) {
          // 如果要去的路由存在于历史记录中，说明是返回操作
          this.transitionName = ''
          // 删除当前路由之后的记录
          this.routeList = this.routeList.slice(0, toIndex + 1)
        } else {
          // 否则是前进操作
          this.transitionName = 'slide-left'
          this.routeList.push(to.fullPath)
        }
        next()
      })
    },
    async getRemainCount() {
      const res = await getRemainCount()
      this.$store.commit("setRemainCount", res.data.experienceCount + res.data.rightsCount)
      this.$store.commit("setPayStatus", res.data.status)
    }
  },
  mounted() {

    this.setParams()
    this.$store.commit("setIsMiniapp", process.env.VUE_APP_TYPE == "miniapp");
    if (GetQueryString("refresh_token")) {
      this.miniappLogin();
    } else {
      this._userOauthMigu();
    }

    const urlfrom = GetQueryString('urlfrom')
    if (urlfrom) {
      localStorage.setItem('urlfrom', urlfrom)
    }
    let full = 1;
    if (full) {
      this.$store.commit("setFullScreen", full);
    }
    const ua = navigator.userAgent;
    if (full == "1" && (ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1)) {
      this.isFullScreen = true; //安卓 
      this.showBackComponent = true;
    }
    if (full == "1" && !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      this.iosFillScreen = true; //ios
      this.showBackComponent = true;
    }
    if (full == "2") {
      this.showBackComponent = true;
    }
    // 初始化时将当前路由添加到历史记录
    this.routeList.push(this.$route.fullPath)
    this.watchRouter()
    this.getRemainCount()
  },
  beforeDestroy() {
    window.removeEventListener('popstate', () => {
      this.isBack = true
    })
  }
};
</script>

<style lang="scss">
#app {
  font-size: 14px;
  position: relative;
  color: $font-color;
}



.slide-left-enter {
  transform: translate(100%, 0);
}

.slide-left-leave-active {
  transform: translate(-100%, 0);
}

// .slide-right-enter {
//   transform: translate(-100%, 0);
// }

// .slide-right-leave-active {
//   transform: translate(100%, 0);
// }

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  position: absolute;
  width: 100%;
  transition: all 0.3s ease-out;
}

.slide-left-enter,
.slide-left-leave-active,
.slide-right-enter,
.slide-right-leave-active {
  opacity: 0;
}
</style>
